'use client'
import {  font12_normal, mq } from '@/styles'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { motion } from 'motion/react'
import { WatchDismissClass } from './WatchDismissClass'
import { useTranslator } from '@/hooks'
import { useParams } from 'next/navigation'

export const BookMobile:FC = () => {
  const [visible, setVisible] = useState(true)
  const { t } = useTranslator()
  const { lang } = useParams()

  return (
    <>
      <WatchDismissClass onAdd={() => setVisible(false)} onRemove={() => setVisible(true)} />
      <LinkStyled href={`https://reservations.portellapalma.com/${lang}/hotel/portellapalma`} initial={{ opacity: 1 }} animate={{ opacity: visible ? 1 : 0 }} transition={{ duration: 0.5 }} rel='noopener noreferrer' target='_blank'>
        {t('project.nav.book')}
      </LinkStyled>

    </>
  )
}

const LinkStyled = styled(motion.a)`
  ${font12_normal(true)}
  align-items: center;
  background: #3C3C3B;
  color: #FFFFFF;
  display: flex;
  flex-shrink: 0;
  gap: 10px;
  height: 45px;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100vw;
  width: 100dvw;
  z-index: 1000;

  ${mq.greaterThan('tablet')} {
    display: none;
  }
`
